import { render } from "./CardChallengeSelectUserItem.vue?vue&type=template&id=0e53265a&scoped=true"
import script from "./CardChallengeSelectUserItem.vue?vue&type=script&lang=js"
export * from "./CardChallengeSelectUserItem.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-select-user-item.css?vue&type=style&index=0&id=0e53265a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e53265a"]])

export default __exports__